







































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SurveyMultipleSelectOptions } from '@/models/survey-elements/multiple-select-options';
import ChoiceElementMixin from '@/mixins/choiceElementMixin';

@Component({
  name: 'multi-select-item',
})
export default class MultipleSelectElement extends ChoiceElementMixin {
  @Prop({ type: Boolean, default: false }) isActive!: Boolean;
  @Prop({ type: Object, required: true }) option!: SurveyMultipleSelectOptions;
  private additionalFieldValue = null;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }

  private get isTextFieldVisible() {
    return this.isActive && this.option.allowCustomValue;
  }

  private onChangeHandler() {
    this.$emit('change', this.option);
  }

  private onTextBoxChangeHandler() {
    this.$emit('custom-value-change', {
      value: this.option.value,
      customValue: this.additionalFieldValue || null,
    });
  }

  @Watch('isTextFieldVisible')
  private onIsTextFieldVisibleChange(currentValue: boolean) {
    this.setFocus(currentValue);

    if (!currentValue) {
      this.additionalFieldValue = null;
      return;
    }
    this.onTextBoxChangeHandler();
  }
}
